export const HEADER_LABELS = {
    "employee-record": 
        {
            firstname: "First Name",
            lastname: "Last Name",
            workemail: "Email",
            title: "Title",
            personalemail: "Personal Email",
            address: "Address",
            personalphone: "Personal Phone",
            employeetype: "Employee Type",
            salarytype: "Salary Type",
            salaryrate: "Salary Rate",
            department: "Department",
            office: "Office",
            designation: "Designation",            
            daysofwork: "Days of Work",
        },
    "another-object": 
        {

        }
}